import Vue from 'vue'
import VueGtag from 'vue-gtag'

export default function({ store, app }) {
  const id = process.env.GTM_ID || store.state.settings.gtmId
  Vue.use(
    VueGtag,
    {
      config: {
        id,
      },
    },
    app.router
  )
}
